<template>
    <div class="downLoadList_container">
        <el-drawer :title="lang.downLoadDetail" :visible.sync="show" direction="rtl" class="downLoadList_drawer" :size="drawerSize">
            <div class="downLoadList_content">
                <div class="downLoadList_item">
                    <h3 class="downLoadList_title">{{ id }}{{ lang.downLoadList }}</h3>
                    <ul class="download-list">
                        <li v-for="file in currentProduct" :key="file.filename" class="download-item">
                            <div class="file-info">
                                <i class="el-icon-document"></i>
                                <span class="filename">{{ file.filename }}</span>
                            </div>
                            <div class="download-action">
                                <a href="#" class="download-link" @click.prevent="downloadFile(file.url, file.filename)">
                                    <i class="el-icon-download"></i>
                                    <span>{{ lang.download || 'Download' }}</span>
                                </a>
                            </div>
                        </li>
                    </ul>
                    <div v-if="currentProduct && currentProduct.length === 0" class="no-files">
                        <i class="el-icon-info"></i>
                        <p>{{ lang.noFilesAvailable || 'No files available for download' }}</p>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import { cloneDeep } from "lodash";
export default {
    model: {
        prop: "value",
        event: "change",
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: "",
        },
    },
    mixins: [],
    name: "downLoadList",
    components: {},
    computed: {
        currentLanguage() {
            return this.$store.state.language.currentLanguage;
        },
        lang() {
            return this.$store.state.language;
        },
        drawerSize() {
            return window.innerWidth <= 768 ? '100%' : '450px';
        }
    },
    watch: {
        value: {
            handler(val) {
                this.show = val;
                if (val) {
                    this.currentProduct = this.allProductsMap[this.id];
                }
            },
        },
        show: {
            handler(val) {
                this.$emit("change", val);
            },
        },
    },
    data() {
        return {
            show: false,
            currentProduct: [],
            allProductsMap: {},
        };
    },
    created() {
        this.allProductsMap = {
            SCORPIO4: [
                { url: "download/SCP4-CN.pdf", filename: "四光吊舱产品规格书-中文版.pdf" },
                { url: "download/SCP4-EN.pdf", filename: "Four-light gimbal product specification sheet - English version.pdf" },
            ],
            LIBRA4: [],
            GEMINI40T:[
                {  url: "download/GEMINI40T-EN.pdf",filename: "GEMINI40 USER MANUAL.pdf"},
                {  url: "download/GEMINI40T-CN.pdf",filename: "GEMINI40用户手册-中文版.pdf"},
            ],
        };
        this.allProductsMap["SCORPIO3"] = cloneDeep(this.allProductsMap["SCORPIO4"]);
        this.allProductsMap["LIBRA3"] = cloneDeep(this.allProductsMap["LIBRA4"]);
        this.allProductsMap["LIBRA2"] = cloneDeep(this.allProductsMap["LIBRA4"]);
    },
    async beforeMount() {},
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        downloadFile(url, filename) {
            const link = document.createElement("a");
            link.href = url;
            link.download = filename;
            console.log(url)
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        handleResize() {
            this.$forceUpdate(); // Force update to recalculate drawer size
        }
    },
};
</script>
<style lang="scss" scoped>
.downLoadList_drawer {
    ::v-deep .el-drawer__header {
        padding: 16px 20px;
        margin-bottom: 0;
        border-bottom: 1px solid #eaeaea;
        color: #333;
        font-weight: 600;
    }
    
    ::v-deep .el-drawer__body {
        padding: 0;
    }
}

.downLoadList_content {
    padding: 20px;
    height: 100%;
    overflow-y: auto;
    background-color: #f9f9f9;
    
    .downLoadList_title {
        font-size: 22px;
        line-height: 1.4;
        padding: 0 0 15px;
        margin: 0 0 20px;
        font-weight: 600;
        border-bottom: 2px solid #e0e0e0;
        color: #333;
    }
    
    .download-list {
        list-style: none;
        padding: 0;
        margin: 0;
    }
    
    .download-item {
        display: flex;
        flex-direction: column;
        padding: 16px;
        margin-bottom: 12px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        transition: all 0.3s ease;
        position: relative;
        
        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
        }
        
        .file-info {
            display: flex;
            align-items: center;
            width: 100%;
            margin-bottom: 16px;
            
            i {
                font-size: 20px;
                color: #666;
                margin-right: 10px;
                flex-shrink: 0;
            }
            
            .filename {
                color: #333;
                font-size: 15px;
                word-break: break-word;
            }
        }
        
        .download-action {
            display: flex;
            justify-content: flex-end;
            width: 100%;
        }
    }
    
    .download-link {
        display: flex;
        align-items: center;
        padding: 8px 16px;
        background-color: #1890ff;
        color: white;
        text-decoration: none;
        font-weight: 500;
        border-radius: 4px;
        transition: all 0.3s ease;
        
        i {
            margin-right: 6px;
        }
        
        &:hover {
            background-color: #096dd9;
            transform: scale(1.05);
        }
    }
    
    .no-files {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 20px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        
        i {
            font-size: 48px;
            color: #bfbfbf;
            margin-bottom: 16px;
        }
        
        p {
            color: #8c8c8c;
            font-size: 16px;
            text-align: center;
        }
    }
}

@media (max-width: 768px) {
    .downLoadList_content {
        padding: 16px;
        
        .download-item {
            .file-info {
                margin-bottom: 20px;
            }
            
            .download-action {
                .download-link {
                    width: 100%;
                    justify-content: center;
                }
            }
        }
    }
}
</style>
